import { SKIP_FORM_FAIL_SAFE } from "../types";

export const skipFormFailSafe = (logs) => ({
  type: SKIP_FORM_FAIL_SAFE,
  payload: logs,
});
